import { CONFIG } from '../app/config.js';
import { ObstacleType } from './ObstacleManager.js';

export class CollisionSystem {
  constructor(options = {}) {
    this.onCollision = options.onCollision || (() => {});
    this.onOrbCollected = options.onOrbCollected || (() => {});
  }

  checkCollisions(character, obstacleManager) {
    if (!character || !obstacleManager) return;

    const runnerX = character.group.position.x;
    const runnerY = character.group.position.y;
    const runnerZ = CONFIG.RUNNER.FIXED_Z;

    const items = obstacleManager.getActiveItems();

    for (let i = 0; i < items.length; i++) {
      const item = items[i];
      if (!item.userData.active || item.userData.collected) continue;

      const itemX = item.position.x;
      const itemY = item.position.y;
      const itemZ = item.position.z;

      const dx = Math.abs(runnerX - itemX);
      const dz = Math.abs(runnerZ - itemZ);

      if (item.userData.type === ObstacleType.ORB) {
        // Collectible orb check
        const orbCenterY = itemY + 0.8;
        const runnerCenterY = runnerY + 0.8;
        const dy = Math.abs(runnerCenterY - orbCenterY);

        // Broadened Z window + sweep check across runner plane (Z = 0)
        const lastZ = item.userData.lastZ !== undefined ? item.userData.lastZ : itemZ;
        const crossedPlane = (lastZ <= runnerZ + 0.6 && itemZ >= runnerZ - 0.6);
        const inZZone = dz < 1.3 || crossedPlane;

        if (dx < 1.15 && inZZone && dy < 1.3) {
          item.userData.collected = true;
          item.userData.isAbsorbing = true;
          item.userData.absorbProgress = 0;
          this.onOrbCollected(item);
        }
      } else if (item.userData.type === ObstacleType.HURDLE) {
        // Low jumpable hurdle
        // Hurdle top is 0.55. If player jump height is above 0.60, hurdle is cleared!
        if (dz < 0.55 && dx < 0.9) {
          if (runnerY < 0.60) {
            this.onCollision(item);
            return; // Run ends on collision
          }
        }
      } else if (item.userData.type === ObstacleType.BLOCKER) {
        // Full lane blocker (cannot jump over)
        if (dz < 0.65 && dx < 0.95) {
          this.onCollision(item);
          return; // Run ends on collision
        }
      }
    }
  }
}
